import React from "react";

import useUniqueId from "components/useUniqueId";

import IconBox from "../../IconBox";

export type BinFillHighIconProps = {
  className?: string;
  /**
   * True if the icon is purely decorative (doesn't add information about content on the page)
   */
  decorative?: boolean;
  /**
   * Label for the icon. Only set if there is no existing element that labels it
   */
  label?: string;
  /**
   * Id of the element that labels this icon
   */
  labelledById?: string;
};

const BinFillHighIcon: React.FC<BinFillHighIconProps> = props => {
  const { decorative, label } = props;
  const labelledBy = useUniqueId();
  const title = label && <title id={labelledBy}>{label}</title>;

  return (
    <IconBox justifyContent="flex-start">
      <svg
        aria-hidden={decorative}
        aria-labelledby={labelledBy}
        className={props.className}
        width="20px"
        height="30px"
        viewBox="0 0 20 30"
        version="1.1"
      >
        {title}
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-976.000000, -3078.000000)">
            <g transform="translate(0.000000, 2880.000000)">
              <g transform="translate(986.000000, 213.000000) rotate(-360.000000) translate(-986.000000, -213.000000) translate(977.000000, 199.000000)">
                <rect
                  stroke="#B7C2C6"
                  fillOpacity="0"
                  fill="#F6F7FA"
                  x="2.27373675e-13"
                  y="0"
                  width="18"
                  height="28"
                  rx="2"
                />
                <rect
                  fill="#76AE1B"
                  x="3"
                  y="3"
                  width="12"
                  height="22"
                  rx="1"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </IconBox>
  );
};

export default BinFillHighIcon;
